import { useQuery } from "react-query";
import axios from "axios";
import {useSelector } from "react-redux";
import {apiUrlSelector} from "../redux/selectors";

export const useProducts = () => {
    const apiUrl = useSelector(apiUrlSelector);
    return useQuery(["products", apiUrl], () =>
        axios.get(`${apiUrl}products`).then(res => res.data.data),
        {
            refetchOnWindowFocus: false,
            placeholderData: []
        }
    );
};

export default useProducts;